import { Guideline, IMSelect, ProductLineTitle, typography } from '@insurancemenu/imenu-components-lib';
import styled from 'styled-components';

export const PortfolioNamesCellStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
`;

export const ProductLineTitleStyled = styled(ProductLineTitle)`
  margin: 0;
`;

export const GuidelinesContentStyled = styled.div`
  ${typography.regular[16]};
`;

export const IMSelectStyled = styled(IMSelect)`
  width: 100%;
  margin-bottom: 1rem;
`;

export const GuidelineStyled = styled(Guideline)`
  margin: 0 0 1rem;
`;
